import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const Toggle = ({ value, onChange }) => (
  <button
    type="button"
    onClick={onChange}
    className={`relative w-12 h-6 rounded-full transition-colors ${value ? 'bg-green-500' : 'bg-zinc-600'}`}
  >
    <span
      className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform ${
        value ? 'right-1' : 'left-1'
      }`}
    />
  </button>
);

const CategoryModal = ({
  language,
  isAdmin,
  editingItem,
  form,
  setForm,
  icons,
  saving,
  onSave,
  onClose,
}) => (
  <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
    <div className="bg-card border border-white/10 rounded-2xl p-6 max-w-md w-full">
      <h3 className="text-xl font-bold text-white mb-4">
        {editingItem
          ? language === 'ar' ? 'تعديل القسم' : 'Edit Category'
          : language === 'ar' ? 'إضافة قسم جديد' : 'Add New Category'}
      </h3>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            {language === 'ar' ? 'الاسم بالعربية' : 'Name (Arabic)'} *
          </label>
          <input
            type="text"
            value={form.name_ar}
            onChange={(e) => setForm({ ...form, name_ar: e.target.value })}
            className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
            placeholder={language === 'ar' ? 'مثال: الشعر' : 'e.g., Hair'}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            {language === 'ar' ? 'الاسم بالإنجليزية' : 'Name (English)'} *
          </label>
          <input
            type="text"
            value={form.name_en}
            onChange={(e) => setForm({ ...form, name_en: e.target.value })}
            className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
            placeholder="e.g., Hair"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            {language === 'ar' ? 'الأيقونة' : 'Icon'}
          </label>
          <div className="flex gap-2">
            {icons.map(({ value, Icon }) => (
              <button
                key={value}
                onClick={() => setForm({ ...form, icon: value })}
                className={`p-3 rounded-lg border transition-all ${
                  form.icon === value
                    ? 'bg-primary/20 border-primary'
                    : 'bg-zinc-800/50 border-white/10 hover:border-white/30'
                }`}
              >
                <Icon
                  className={`w-5 h-5 ${form.icon === value ? 'text-primary' : 'text-muted-foreground'}`}
                />
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            {language === 'ar' ? 'ترتيب العرض' : 'Display Order'}
          </label>
          <input
            type="number"
            value={form.display_order}
            onChange={(e) => setForm({ ...form, display_order: parseInt(e.target.value) || 0 })}
            className="w-full bg-zinc-800/50 border border-white/10 rounded-lg px-4 py-2 text-white"
            min="0"
          />
        </div>

        {isAdmin && (
          <div className="border-t border-white/10 pt-4 mt-4 space-y-3">
            <p className="text-sm font-medium text-muted-foreground mb-2">
              {language === 'ar' ? 'إعدادات الظهور' : 'Visibility Settings'}
            </p>
            <div className="flex items-center justify-between">
              <label className="text-sm text-foreground">
                {language === 'ar' ? 'إظهار للزوار' : 'Visible to visitors'}
              </label>
              <Toggle
                value={form.is_visible}
                onChange={() => setForm({ ...form, is_visible: !form.is_visible })}
              />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm text-foreground">
                {language === 'ar' ? 'إظهار الأسعار' : 'Show prices'}
              </label>
              <Toggle
                value={form.show_price}
                onChange={() => setForm({ ...form, show_price: !form.show_price })}
              />
            </div>
          </div>
        )}
      </div>

      <div className="flex gap-3 mt-6">
        <Button onClick={onSave} className="flex-1 bg-primary" disabled={saving}>
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : language === 'ar' ? 'حفظ' : 'Save'}
        </Button>
        <Button onClick={onClose} variant="outline" className="flex-1">
          {language === 'ar' ? 'إلغاء' : 'Cancel'}
        </Button>
      </div>
    </div>
  </div>
);

export default CategoryModal;
export { Toggle };
